import react from 'react';
import { addComma } from 'constants/utils';
import { ISectionsInfo } from 'screens/salary_specification/detail/DetailPay';
import { IEmpInPayTransfer } from 'types/salary';

interface IProps {
  Title: string;
  TableData: ISectionsInfo[];
  DetailData?: IEmpInPayTransfer;
  PAYTYPE?: string;
}

const SectionTableInfo = ({ Title, TableData, DetailData, PAYTYPE = '' }: IProps) => {
  // console.log('Title', Title);
  // console.log('TableData', TableData);

  return (
    <div className="DP_SectionTable">
      <strong>{Title}</strong>
      <table>
        <thead>
          <tr>
            <th>항목</th>
            <th>산출식</th>
            <th>값</th>
          </tr>
        </thead>
        <tbody>
          {TableData.map((item, index) => {
            // console.log("item_ 지급 계산 내역: ", item);
            let TITLE = item.title;
            if (item.title == '기본급' && PAYTYPE == '3') {
              TITLE = `${item.title}(주휴수당포함)`;
            }

            // console.log('item.title', item.title);
            let HIDE = false;
            if (DetailData?.STANDARD_TAX == '1') {
              if (
                item.title == '국민연금' ||
                item.title == '건강보험' ||
                item.title == '장기요양보험' ||
                item.title == '고용보험'
              ) {
                HIDE = true;
              }
            }
            if (DetailData?.STANDARD_TAX == '2') {
              if (
                item.title == '국민연금' ||
                item.title == '건강보험' ||
                item.title == '장기요양보험' ||
                item.title == '고용보험' ||
                item.title == '근로소득세' ||
                item.title == '지방소득세'
              ) {
                HIDE = true;
              }
            }
            return (
              <tr key={index}>
                {item.title == '기본급' ? (
                  <td>{TITLE}</td>
                ) : item.title == '식대' || item.title == '자가운전보조금' || item.title == '육아수당' ? (
                  <td>{item.title}(비과세)</td>
                ) : (
                  <td>{item.title}</td>
                )}
                {HIDE == true ? (
                  <td className="DP_SectionTableFormula">-</td>
                ) : (
                  <td className="DP_SectionTableFormula">{item.formula !== '' ? item.formula : '-'}</td>
                )}
                <td>{addComma(item.value)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SectionTableInfo;
